module.exports = __webpack_public_path__ + "static/img/nirsal-main.bf52bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/nirsal-main.png
// module id = Z5sZ
// module chunks = 1